import api from '../utils/api.js'
export default {
	statistics(id,name,source,materialType,access,operateType,viewTime){
		console.log(materialType)
		var userType = localStorage.getItem('userType');
		var userId = localStorage.getItem('userId');
		var type = materialType;
		if(viewTime > 0){
			if(materialType == 2){
				type = 3
			}else if(materialType == 3){
				type = 4
			}else if(materialType == 4){
				type = 5
			}else if(materialType == 1){
				type = 2
			}
		}
		
		const params = {
			materialId:id,
			materialName:name,
			materialSource:source,
			materialType:type,
			operateAccess:access,
			operateType:operateType,
			userId:userId,
			previewDuration:viewTime/1000
		}
		console.log('userType',userType)
		// var url = '/axt-statistics/statistics_teacher/addMaterialUseRecord';
		if(userType == 'teacher'){
			var url = '/axt-statistics/statistics_teacher/addMaterialUseRecord';
			
		}else{
			var url = '/axt-statistics/statistics_student/addRecord'
		}
		api.postFormAPI(url,params).then(res => {
			console.log(res)
		}).catch(error => {
			console.log(error)
		})
	},
	testPater(id,name,access,operateType,source,viewTime){
		var userType = localStorage.getItem('userType');
		var userId = localStorage.getItem('userId');
		const params = {
			examinationPaperId:id,
			examinationPaperName:name,
			source:source,
			operateAccess:access,
			operateType:operateType,
			userId:userId,
			previewDuration:viewTime/1000
		}
		
		if(userType == 'teacher'){
			var url = '/axt-statistics/statistics_teacher/addExaminationPaperUseRecord';
			
		}else{
			var url = '/axt-statistics/statistics_student/addExaminationPaperUseRecord'
		}
		api.postFormAPI(url,params).then(res => {
			console.log(res)
		}).catch(error => {
			console.log(error)
		})
	}
} 




// WEBPACK FOOTER //
// ./src/assets/statistics.js